import {
    preloadAndInitializeCalendarProviderAccounts,
    loadCalendarProviderAccounts,
} from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { initializeCalendarProviderAccountAddHandlers } from './addCalendarProviderAccountOrchestrator';

let hasInitialized = false;
orchestrator(preloadAndInitializeCalendarProviderAccounts, () => {
    if (!hasInitialized) {
        // As we only want to initialize once so looking at the flag
        loadCalendarProviderAccounts();
        initializeCalendarProviderAccountAddHandlers();
        hasInitialized = true;
    }
});
